//angular
import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatIconRegistry } from '@angular/material/icon';
//app
import { RestResponse } from 'src/app/_shared/models';
import { NotificationSectionValues } from 'src/app/app.data';
import { slideInRightAnimation, smoothAppearance } from 'src/app/_shared/animations';
import { SettingsService } from '../../../_services/api/settings.service';
import { ValidatorService } from 'src/app/_shared/validators/validator.service';
import { MetaService } from 'src/app/_core/services/meta.service';
import { Unsubscriber } from 'src/app/_shared/unsubscriber/unsubscriber';

@Component({
  animations: [smoothAppearance, slideInRightAnimation],
  selector: 'inbox',
  templateUrl: './inbox.component.html'
})

export class InboxComponent implements OnInit, OnDestroy {
  collectionOfFields: any;
  form: FormGroup;
  formSubmitted: boolean = false;
  isFormReady:boolean = true;
  notificationSectionKeyName: NotificationSectionValues;
  templateId: number;
  private subs = new Unsubscriber();

  constructor(
    private _fb: FormBuilder,
    private _iconRegistry: MatIconRegistry,
    public _meta: MetaService,
    private _route: ActivatedRoute,
    private _router: Router,
    private _sanitizer: DomSanitizer,
    private settingsService: SettingsService,
    private _validatorService: ValidatorService,
  ) {
    this._iconRegistry.addSvgIcon('ico-actions', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-actions-01.svg'));
    this._iconRegistry.addSvgIcon('ico-bullet', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-bullet-01.svg'));
    this._iconRegistry.addSvgIcon('ico-disabled', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-switch-03.svg'));
    this._iconRegistry.addSvgIcon('ico-dropdown', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-arrow-down-01.svg'));
    this._iconRegistry.addSvgIcon('ico-edit', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-edit-02.svg'));
    this._iconRegistry.addSvgIcon('ico-enabled', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-switch-05.svg'));
    this._iconRegistry.addSvgIcon('ico-error', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-error-02.svg'));
    this._iconRegistry.addSvgIcon('ico-loading', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-loading-01.svg'));
    this._iconRegistry.addSvgIcon('ico-preview', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-wizard-01.svg'));
    this._iconRegistry.addSvgIcon('ico-settings', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-settings-02.svg'));
    this._iconRegistry.addSvgIcon('ico-switch', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-switch-01.svg'));
    this._iconRegistry.addSvgIcon('ico-back', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-back-03.svg'));
    this._iconRegistry.addSvgIcon('ico-loader', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-loading-01.svg'));
    this._iconRegistry.addSvgIcon('ico-loading', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-loading-01.svg'));

    this.subs.addSub = this._route.params.subscribe((params) => {
      this.notificationSectionKeyName = params['notificationSectionKeyName'];
    });

    this.subs.addSub = this._route.params.subscribe((params) => {
      this.templateId = params['id'];
    });
  }

  addField(field) {
    this.form.get('contentText').setValue(`${this.form.get('contentText').value} ${field.keyName}`);
  }

  getTemplateById(_templateId: number) {
    this.subs.addSub = this.settingsService.getTemplateByTemplateId(_templateId).subscribe(
        (res: any) => {
          this.form.patchValue({
            contentText: res.data.contentText
          });
          this.collectionOfFields = res.data.fields;
        },
        (err: RestResponse) => {
          this._meta.showNotification(err);
        }
      );
  }

  ngOnInit() {
    this.setUpForm();
    this.getTemplateById(this.templateId);
  }

  setUpForm() {
    this.form = this._fb.group({
      contentText: ['', [Validators.required, this._validatorService.emptySpace]],
    });
  }

  onSubmit() {
    this.formSubmitted = !this.formSubmitted;

    if (this.form.invalid) {
      this.formSubmitted = !this.formSubmitted;
      this.form.markAllAsTouched();
      this.form.markAsDirty();
      return;
    }

    const bodyParams = {
      contentText: this.form.get('contentText').value
    };

    this.updateTemplate(bodyParams);
  }

  updateTemplate(_bodyParams: any) {
    this.subs.addSub = this.settingsService.updateTemplateByTemplateId(this.templateId,_bodyParams).subscribe(
      (res: RestResponse) => {
        this.formSubmitted = !this.formSubmitted;
        this._meta.showNotification(res);
        this._router.navigate(['/main/settings/advanced/notifications/',this.notificationSectionKeyName,'list']);
      },
      (err: RestResponse) => {
        this.formSubmitted = !this.formSubmitted;
        this._meta.showNotification(err);
      }
    );
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
